export default __webpack_public_path__ + "static/media/edit_pencil_teal.b128ae06.svg";